import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { getEditNameInfo } from '../../user/actions/GetInfo'
import { clearTransaction } from '../../user/actions/transactions/Clear'
import { sendRawTransaction } from '../../user/actions/transactions/EditName'
import { connect } from 'react-redux'
import {
  Container,
  Segment,
  Header,
  Form,
  Button,
  Message,
  Modal
} from 'semantic-ui-react'
import lightwallet from 'eth-lightwallet'

class EditName extends Component {
	
    constructor(props) {
        super(props)

        this.state = {
            userName: '',
            errorMessage: false,
            errorMessageText: '',
            showModal: false,
            checkPassword: '',
            checkConfirmPassword: ''
        }
    }
	
    componentWillMount(){
		
        let { dispatch, memberId, balanceIn, authData } = this.props
		
        if(memberId === '0' || balanceIn === '0 ETH'){
            return browserHistory.push('/city')
        }

        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()

        dispatch(getEditNameInfo(address[0]))
    }
	
    componentWillReceiveProps(nextProps){

        let { showHashModal, memberId, balanceIn  } = nextProps

        if(memberId === '0' || balanceIn === '0 ETH'){
            return browserHistory.push('/city')
        }

        if(showHashModal){
            this.setState({ showModal: false, checkPassword:'', checkConfirmPassword:''})
        }

    }

    transactionIsDone(){

        let { dispatch } = this.props

        dispatch(clearTransaction())
        
        browserHistory.push('/city')
    }

    checkPasswordOnInputChange(event) {
        this.setState({ checkPassword: event.target.value})
    }
	
    checkPasswordConfirmOnInputChange(event) {
        this.setState({ checkConfirmPassword: event.target.value})
    }
	
    nameOnInputChange(event) {
        this.setState({ userName: event.target.value })
    }

    inputNameSubmit(event) {
        event.preventDefault()
        
        let { dispatch } = this.props

        let name = this.state.userName

        if (name.trim() === ''){
            return this.setState({ errorMessage: true, errorMessageText: 'Your name is empty.' })
        }
        
        dispatch(clearTransaction())

        this.setState({ errorMessage: false, showModal: true})
    }
	
    checkPasswordSubmitMemberEdit(event) {
        event.preventDefault()
		
        let { checkPassword, checkConfirmPassword, userName } = this.state

        let { dispatch, authData } = this.props

        let keystore = authData.keystore
       
        dispatch(sendRawTransaction(keystore, userName, checkPassword, checkConfirmPassword))  
    }
	
    render() {

        let { errorMessage, errorMessageText, showModal, userName, checkPassword, checkConfirmPassword } = this.state

        let { memberId, balanceIn, citizenName, checkLoading, checkErrorMessage, checkErrorMessageText, showHashModal, transactionHash } = this.props

        if(memberId === 'N-N' || balanceIn === 'N-N'){
            return(<Segment style={{  minHeight: 700 }} vertical loading />)
        }

        if(memberId !== '0' || balanceIn !== '0 ETH'){
            return(
                <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                    <Container>
                        <Header as='h1' content={'Change Your Name, '+citizenName} style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}/>
                        <Container textAlign='left' text>
                            <Message error hidden={!errorMessage} content={errorMessageText}/>
                            <Form size='large' onSubmit={this.inputNameSubmit.bind(this)}>
                                <Form.Field>
                                    <label>New name</label>
                                    <input placeholder='Enter new name' value={userName} onChange={this.nameOnInputChange.bind(this)} />
                                </Form.Field>
                                <Button.Group size='large'>
                                    <Button positive type='submit'>Submit</Button>
                                </Button.Group>
                            </Form>
                        </Container>
                    </Container>
                    <Modal size='mini' open={showModal} closeOnEscape={!checkLoading} closeOnRootNodeClick={!checkLoading} onClose={() => this.setState({showModal:false, checkPassword:'', checkConfirmPassword:''})} closeIcon={!checkLoading}>
                        <Modal.Header>
                            Confirm your password
                        </Modal.Header>
                        <Modal.Content>
                            <Message error hidden={!checkErrorMessage} content={checkErrorMessageText}/>
                            <Form size='small' onSubmit={this.checkPasswordSubmitMemberEdit.bind(this)} loading={checkLoading}>
                                <Form.Field>
                                    <label>Password</label>
                                    <input type='password' minLength='6' autoComplete='new-password' placeholder='Password' value={checkPassword} onChange={this.checkPasswordOnInputChange.bind(this)} />
                                </Form.Field>
                                <Form.Field>
                                    <label>Confirm Password</label>
                                    <input type='password' minLength='6' autoComplete='current-password' placeholder='Confirm Password' value={checkConfirmPassword} onChange={this.checkPasswordConfirmOnInputChange.bind(this)} />
                                </Form.Field>
                                <Button.Group size='small'>
                                    <Button positive type='submit'>Submit</Button>
                                </Button.Group>
                                <p style={{fontSize: '0.7em'}}>* The transaction can take about a minute</p>
                            </Form>
                        </Modal.Content>
                    </Modal>
                    <Modal basic size='small' open={showHashModal} onClose={() => this.transactionIsDone()} closeIcon>
                        <Header content='Transaction Hash' />
                        <Modal.Content>
                            <p>Transaction successfully processed. <a href={'https://rinkeby.etherscan.io/tx/'+transactionHash} target="_blank">Here</a> you can find all information about it.</p>
                        </Modal.Content>
                    </Modal>
                </Segment>
                )
        } else {
            return (null);
        }
    }
}

const mapStateToProps = (state) => {
    return {
        memberId: state.city.data.memberId,
        citizenName: state.city.data.citizenName,
        balanceIn: state.city.data.balanceIn,
        checkLoading: state.transaction.data.checkLoading,
        checkErrorMessage: state.transaction.data.checkErrorMessage,
        checkErrorMessageText: state.transaction.data.checkErrorMessageText,
        showHashModal: state.transaction.data.showHashModal, 
        transactionHash: state.transaction.data.transactionHash
    }
}

export default connect(mapStateToProps)(EditName)

EditName.propTypes = {
    memberId: PropTypes.string,
    balanceIn: PropTypes.string,
    citizenName: PropTypes.string,
    authData: PropTypes.object,
    dispatch: PropTypes.func,
    checkLoading: PropTypes.bool,
    checkErrorMessage: PropTypes.bool,
    checkErrorMessageText: PropTypes.string,
    showHashModal: PropTypes.bool, 
    transactionHash: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/layouts/city/EditName.js